import { createFileRoute } from '@tanstack/react-router';
import { ExpenseApprovalsPage } from '@/features/finance';

/** `/o/$orgId/finance/expenses/approvals`: the link of the "expense to approve" notification. */
export const Route = createFileRoute('/_auth/o/$orgId/finance/expenses/approvals')({
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  const { orgId } = Route.useParams();
  return <ExpenseApprovalsPage orgId={orgId} />;
}
